import { Button, Input, InputProps } from "@fluentui/react-components";
import React, { useState } from "react";
import { ResourceSpaceType } from "../../APIService/ResourceSpaceTypeListService";
import "./ResourceSpaceFindSection.css";
import { FaCaretRight } from "react-icons/fa";
import { FaSortDown } from "react-icons/fa6";
import { IoAddCircleOutline } from "react-icons/io5";
import { AiOutlineMinusCircle } from "react-icons/ai";
import { PiOfficeChairFill } from "react-icons/pi";
import { SpaceDetail } from "../../APIService/UserBookingService";
import SelectDropDown from "../SelectDropDown";
import { Equipment, Resource, ResourceEquipment } from "../../APIService/SearchService";

type ResourceSpaceFindSectionProps = {
  spaceType: ResourceSpaceType;
  spaceTypes: ResourceSpaceType[];
  equipmentList: Equipment[];
  tagsList: string[]
  availableResourceList: Resource[];
  onChangeSearchText: (text: string) => void;
  onChangeOccupancyCount: (count: number) => void;

  //On change callback for dropdowns
  onChangeSpaceType: (spaceType: ResourceSpaceType) => void;
  onEquipmentSelect: (equipments: Equipment[]) => void;
  onTagsSelect: (tags: string[]) => void;

  //Selected
  selectedEquipmentList: Equipment[];
  selectedTagsList: string[];
  occupancyCount: number;
};

const ResourceSpaceFindSection = ({
  spaceType,
  spaceTypes,
  equipmentList,
  tagsList,
  availableResourceList,
  onChangeSearchText,
  onChangeSpaceType,
  onEquipmentSelect,
  onTagsSelect,
  selectedEquipmentList,
  selectedTagsList,
  onChangeOccupancyCount,
  occupancyCount
}: ResourceSpaceFindSectionProps) => {
  const [openId, setOpenId] = useState<number | null>(null);
  const BookingSpaceDetails = ({ resource }: { resource: Resource }) => {
    const isOpen = openId === resource.Id;

    return (
      <div className="avaliable-spaceContainer">
        <div className="avaliable-space">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            {isOpen ? (
              <FaSortDown
                size={14}
                style={{ marginRight: 10, cursor: "pointer" }}
                onClick={() => setOpenId(null)}
              />
            ) : (
              <FaCaretRight
                size={12}
                style={{ marginRight: 10, cursor: "pointer" }}
                onClick={() => setOpenId(resource.Id)}
              />
            )}

            <span>
              {resource.ResName}
            </span>

            {!isOpen && (
              <>
                <span className="vertical-line" />

                <div style={{ display: "flex", alignItems: "center" }}>
                  <PiOfficeChairFill />
                  <span style={{ marginLeft: 5 }}>{resource.Occupancy}</span>
                </div>

                <span className="vertical-line" />

                <div className="header-icon">
                  {resource.Equipment?.map((eq: ResourceEquipment) => (
                    <div
                      key={eq.EquipmentId}
                      style={{
                        backgroundColor: "#454545",
                        padding: 5,
                        borderRadius: 2,
                        margin: 3,
                      }}
                    >
                      <img
                        src={localStorage.getItem("tenantUrl") + (( eq.Status && eq.Status === 2) ? eq.FaultImagePath : eq.ImagePath)}
                        alt={eq.Name}
                        style={{ height: 16, width: 16 }}
                      />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          <Button size="small" shape="circular">
            Add to Booking
          </Button>
        </div>

        {isOpen && (
          <>
            <div className="space-details">
              <PiOfficeChairFill />
              <span style={{ marginLeft: 5 }}>{resource.Occupancy}</span>

              {resource.Equipment?.map((eq: any) => (
                <Button
                  key={eq.EquipmentId}
                  size="small"
                  icon={
                    <img
                      src={localStorage.getItem("tenantUrl") + eq.ImagePath}
                      style={{ height: 15, width: 15 }}
                    />
                  }
                  iconPosition="before"
                  style={{ marginLeft: 5 }}
                >
                  {eq.Name}
                </Button>
              ))}
            </div>

            {resource.RoomImage && (
              <div className="space-details">
                <img
                  src={localStorage.getItem("tenantUrl") + resource.RoomImage}
                  style={{
                    width: "20%",
                    borderRadius: 10,
                  }}
                />
              </div>
            )}
          </>
        )}

        <hr />
      </div>
    );
  };

  const onChange: InputProps["onChange"] = (ev, data) => {
    onChangeSearchText(data.value);
  }

  return (
    <div className="findContainer">
      <div style={{ height: 34, padding: "4px 4px 5px 4px", border: "1px solid #525252", borderRadius: '3px', boxSizing: "border-box", marginBottom: 10, display: "flex", alignItems: "center"}}>
        <Input
          placeholder="Search..."
          size="small"
          style={{ width: "100%", height: 23, fontSize: 13, border:  '0px'}}
          onChange={onChange}
        />
      </div>

      <div className="dropdown-row">
        <SelectDropDown<ResourceSpaceType>
          data={spaceTypes}
          placeholder="Space Type"
          getId={item => item.id.toString()}
          getLabel={item => item.name}
          getIcon={item => item.icon ?? undefined}
          defaultValue={spaceType}
          onChange={(selected) => {
            const space = selected.item;
            onChangeSpaceType(space);
          }}
        />

        <SelectDropDown<Equipment>
          data={equipmentList}
          placeholder="Equipment"
          getId={item => item.id.toString()}
          getLabel={item => item.name}
          getIcon={item => item.icon ?? undefined}
          multiselect
          defaultValue={selectedEquipmentList}
          onChange={(selected) => {
            const equipments = selected.map(s => s.item);
            onEquipmentSelect(equipments);
          }}
        />

        <SelectDropDown<string>
          data={tagsList}
          placeholder="Tags"
          getId={item => item}
          getLabel={item => item}
          multiselect
          defaultValue={selectedTagsList}
          onChange={(selected) => {
            const tags = selected.map(s => s.item);
            onTagsSelect(tags);
          }}
        />

        <Button
          className="occupancyButton"
          appearance="outline"
          shape="circular"
          size="small"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <span
            style={{
              display: "flex",
              gap: 8,
              alignItems: "center",
            }}
          >
            Occupancy
          </span>
          <AiOutlineMinusCircle
            onClick={() =>
              occupancyCount > 0 ? onChangeOccupancyCount(occupancyCount - 1) : 0
            }
          />
          <span>{occupancyCount}</span>
          <IoAddCircleOutline
            onClick={() => onChangeOccupancyCount(occupancyCount + 1)}
          />
        </Button>
      </div>
      <div className="spaceTypeContainer">
        {spaceType.icon && (
          <img
            className="spaceType-icon"
            src={localStorage.getItem("tenantUrl") + spaceType.icon}
            alt=""
          />
        )}
        <p>{spaceType.name}</p>
      </div>
      <div className="resultsScroll">
        {availableResourceList.map((resource: Resource) => (
          <BookingSpaceDetails key={resource.Id} resource={resource} />
        ))}
      </div>
    </div>
  );
};

export default ResourceSpaceFindSection;
